export type SortDirection = 'asc' | 'desc' | null;

export interface SortEvent<T> {
  column: keyof T;
  direction: SortDirection;
}
